/**
 * Bloc "Vidéo par variante"
 * -------------------------------------------------------------------------
 * Affiche la vidéo native taguée pour la couleur actuellement sélectionnée
 * (mêmes conventions que la galerie : [colors:Nom] / [colors:A|B] /
 * [all-colors] / #couleur_Nom). Si aucune vidéo ne correspond, le bloc reste
 * invisible — jamais de vidéo par défaut affichée.
 *
 * Réutilise les données déjà exposées par la galerie sur la même section
 * (mapping variante -> couleur, index de l'option couleur) plutôt que de les
 * recalculer : voir snippets/main-product__media-gallery.liquid.
 */
(function () {
  'use strict';

  function normalize(str) {
    if (!str) return '';
    return str
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
  }

  function getVideoColorMap(block) {
    var sectionId = block.dataset.section;
    var mapScript = document.querySelector(
      'script[data-video-color-map][data-section="' + sectionId + '"]'
    );
    if (!mapScript) return null;

    try {
      var raw = JSON.parse(mapScript.textContent);
      var map = {};
      Object.keys(raw).forEach(function (mediaId) {
        var entry = raw[mediaId] || {};
        map[mediaId] = {
          all: !!entry.all,
          colors: (entry.colors || []).map(normalize).filter(Boolean)
        };
      });
      return map;
    } catch (e) {
      return null;
    }
  }

  function getVariantColorMap(sectionId) {
    var mapScript = document.querySelector(
      'script[data-variant-color-map][data-section="' + sectionId + '"]'
    );
    if (!mapScript) return null;

    try {
      var map = JSON.parse(mapScript.textContent);
      return (map && typeof map === 'object') ? map : null;
    } catch (e) {
      return null;
    }
  }

  function getCurrentColor(sectionId) {
    var gallery = document.getElementById('MediaGallery-' + sectionId);
    if (!gallery) return null;

    var colorOptionIndex = parseInt(gallery.dataset.colorOptionIndex, 10);
    if (isNaN(colorOptionIndex) || colorOptionIndex < 0) return null;

    var productInfo = gallery.closest('product-info');
    if (!productInfo) return null;

    var variantScript = productInfo.querySelector(
      'product-variant-selects [data-selected-variant]'
    );
    if (!variantScript || !variantScript.textContent.trim()) return null;

    var variant;
    try {
      variant = JSON.parse(variantScript.textContent);
    } catch (e) {
      return null;
    }
    if (!variant) return null;

    var variantColorMap = getVariantColorMap(sectionId);
    if (variantColorMap && variant.id !== undefined && variantColorMap[variant.id] !== undefined) {
      return normalize(variantColorMap[variant.id]);
    }

    if (!variant.options) return null;
    return normalize(variant.options[colorOptionIndex]);
  }

  function pauseVideo(item) {
    var video = item.querySelector('video');
    if (video) {
      try { video.pause(); } catch (e) {}
    }
  }

  function playVideo(item) {
    var video = item.querySelector('video');
    if (video) {
      video.muted = true;
      video.play().catch(function () {
        // Lecture automatique refusée par le navigateur : les contrôles
        // natifs (si affichés) permettent de la lancer manuellement.
      });
    }
  }

  function applyBlock(block) {
    var sectionId = block.dataset.section;
    var colorMap = getVideoColorMap(block);
    var currentColor = colorMap ? getCurrentColor(sectionId) : null;

    var items = Array.prototype.slice.call(
      block.querySelectorAll('.product__variant-video--item')
    );

    if (!colorMap || !currentColor) {
      items.forEach(function (item) {
        item.classList.remove('active');
        pauseVideo(item);
      });
      block.classList.add('hidden');
      return;
    }

    var matchFound = null;
    items.forEach(function (item) {
      var mediaId = item.dataset.mediaId;
      var entry = colorMap[mediaId];
      var matches = entry && (entry.all || entry.colors.indexOf(currentColor) !== -1);
      if (matches && !matchFound) {
        matchFound = item;
      }
    });

    items.forEach(function (item) {
      if (item === matchFound) {
        item.classList.add('active');
        playVideo(item);
      } else {
        item.classList.remove('active');
        pauseVideo(item);
      }
    });

    if (matchFound) {
      block.classList.remove('hidden');
    } else {
      block.classList.add('hidden');
    }
  }

  function applyToAllBlocks() {
    var blocks = document.querySelectorAll('.product__variant-video');
    blocks.forEach(applyBlock);
  }

  // 1) Chargement initial
  applyToAllBlocks();

  // 2) Re-passage après chargement complet
  window.addEventListener('load', applyToAllBlocks);

  // 3) Changement de variante sans rechargement (pub/sub déjà utilisé par le thème)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      setTimeout(applyToAllBlocks, 0);
    });
  }

  // 4) Navigation précédent/suivant du navigateur
  window.addEventListener('popstate', function () {
    setTimeout(applyToAllBlocks, 0);
  });
})();
